import { useState, useEffect, useCallback } from 'react';
import getExerciseStats from '../../api/getExerciseStats';

export default function useLastPerformance(
    athleteId,
    workoutSetExercise,
    date
) {
    const [lastPerformanceValue, setLastPerformanceValue] = useState(null);
    const [
        lastPerformanceSavedWorkoutSetExercise,
        setLastPerformanceSavedWorkoutSetExercise
    ] = useState(null);
    const [isLift, setIsLift] = useState(false);
    const [workingMaxValue, setWorkingMaxValue] = useState(null);
    const [workingMaxUnits, setWorkingMaxUnits] = useState(null);
    const isSupported = !!athleteId;

    const fetchStats = useCallback(
        async () => {
            if (!athleteId || !workoutSetExercise.exercise_id) {
                return;
            }
            const response = await getExerciseStats(
                athleteId,
                workoutSetExercise.exercise_id,
                date
            );
            const lastPerformance = response.lastPerformance
                ? response.lastPerformance.text
                : null;
            setLastPerformanceValue(lastPerformance);
            setIsLift(response.isLift);

            const savedWorkoutSetExercise = response.lastPerformance
                ? response.lastPerformance.savedWorkoutSetExercise
                : null;
            setLastPerformanceSavedWorkoutSetExercise(savedWorkoutSetExercise);

            if (!response.isLift) {
                return;
            }

            const value = response.workingMax
                ? response.workingMax.value
                : null;
            setWorkingMaxValue(value);
            const units = response.workingMax
                ? response.workingMax.units
                : null;
            setWorkingMaxUnits(units);
        },
        [athleteId, date, workoutSetExercise]
    );

    useEffect(
        () => {
            fetchStats();
        },
        [athleteId, date, fetchStats, workoutSetExercise]
    );

    const reloadLastPerformance = () => {
        return fetchStats();
    };

    return {
        isSupported,
        lastPerformanceValue,
        lastPerformanceSavedWorkoutSetExercise,
        isLift,
        workingMaxValue,
        workingMaxUnits,
        reloadLastPerformance
    };
}



// WEBPACK FOOTER //
// ./src/v5/LastPerformance/components/hooks/useLastPerformance.js